import Form from '../../../../../../components/form';
import request from '../../../../../../utils/request';
import CoList from './co_list.vue';

formCreate.component('CoList', CoList);
export default {
  extends: Form,
  components: {},
  data() {
    return {
      formFunctionCode: 'budget_subjects_form',
    };
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'coReqVos') {
        v.props = {
          ...v.props,
          getValue: (field) => this.getFieldValue(field),
        };
        v.value = [
          {
            orgReqVos: [],
            coBudgetYear: '',
            coBudgetSubjectName: '',
            coBudgetSubjectCode: '',
            coCompanyName: '',
            coCompanyCode: '',
            unionOrgName: '',
            unionOrgCode: '',
          },
        ];
      }
      return v;
    },
    // 表单渲染完成后的回调
    formComplete() {
      this.hiddenFields(true, ['coReqVos']);
      const carryoverIs = this.getRule('carryoverIs');
      // 预算科目
      carryoverIs.on.change = (e) => {
        if (e === 'N' || !e) {
          this.hiddenFields(true, ['coReqVos']);
        } else {
          this.hiddenFields(false, ['coReqVos']);
        }
      };
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        request.get('/tpm/tpmBudgetSubjectsExt/query', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            if (res.result.carryoverIs === 'N' || !res.result.carryoverIs) {
              this.hiddenFields(true, ['coReqVos']);
            } else {
              this.hiddenFields(false, ['coReqVos']);
            }
            const { result } = res;
            if (result.coRespVos && result.coRespVos.length > 0) {
              result.coReqVos = result.coRespVos.map((v) => {
                const obj = v;
                if (obj.coBudgetYear) {
                  obj.coBudgetYear = obj.coBudgetYear.split(',');
                }
                obj.orgReqVos = obj.orgRespVos;
                return obj;
              });
            }
            this.setValue(result);
          }
        });
      }
    },

    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        if (formData.coReqVos && formData.coReqVos.length > 0) {
          formData.coReqVos = formData.coReqVos.map((v) => {
            const obj = v;
            if (obj.coBudgetYear && obj.coBudgetYear.length > 0) {
              obj.coBudgetYear = obj.coBudgetYear.join(',');
            } else {
              obj.coBudgetYear = null;
            }
            return obj;
          });
        }
        let url = '/tpm/tpmBudgetSubjectsExt/save';
        const params = { ...formData };

        if (this.formConfig.code === 'edit') {
          url = '/tpm/tpmBudgetSubjectsExt/update';
          params.id = this.formConfig.row.id;
        }

        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
